import type { Module } from 'vuex';
import { Indicator } from '@/types/Indicator';
import {RootState} from "@/store";

export interface IndicatorState {
  indicator: Indicator | null;
  deleted: boolean;
}

const indicatorModule: Module<IndicatorState, RootState> = {
  namespaced: true,

  state: (): IndicatorState => ({
    indicator: null,
    deleted: false,
  }),

  mutations: {
    setIndicator(state, payload: { idIndicator: number; name: string; math: string | null; locked: boolean; }) {
      state.indicator = new Indicator(
        payload.idIndicator,
        payload.name,
        payload.math,
        payload.locked,
      );
      state.deleted = false;
    },
    setIndicatorUpdate(state, payload: { idIndicator: number; name?: string; math?: string | null; locked?: boolean; }) {
      if (!state.indicator || state.indicator.idIndicator !== payload.idIndicator) return;
      if (payload.name !== undefined) state.indicator.name = payload.name;
      if (payload.math !== undefined) state.indicator.math = payload.math;
      if (payload.locked !== undefined) state.indicator.locked = payload.locked;
    },
    setIndicatorDelete(state, payload: { idIndicator: number }) {
      if (state.indicator?.idIndicator === payload.idIndicator) {
        state.deleted = true;
      }
    },
    setIndicatorLock(state, payload: { idIndicator: number }) {
      if (state.indicator?.idIndicator === payload.idIndicator) {
        state.indicator.locked = true;
      }
    },

    setIndicatorUnlock(state, payload: { idIndicator: number }) {
      if (state.indicator?.idIndicator === payload.idIndicator) {
        state.indicator.locked = false;
      }
    },
    clearIndicator(state) {
      state.indicator = null;
      state.deleted = false;
    },
  },

  actions: {
    wsSetIndicator({ commit }, payload) {
      commit('setIndicator', payload);
    },
    wsSetEmptyIndicator({ commit }) {
      commit('clearIndicator');
    },
    wsIndicatorUpdate({ commit }, payload) {
      commit('setIndicatorUpdate', payload);
    },
    wsIndicatorDelete({ commit }, payload) {
      commit('setIndicatorDelete', payload);
    },
    wsIndicatorLock({ commit }, payload) {
      commit('setIndicatorLock', payload);
    },
    wsIndicatorUnlock({ commit }, payload) {
      commit('setIndicatorUnlock', payload);
    },
    clearIndicator({ commit }) {
      commit('clearIndicator');
    },
  },
};

export default indicatorModule; 